import { FC, ReactNode, useState } from "react";
import Header from "./main/Header";
import NavBar from "./main/NavBar";
import Footer from "./main/Footer";
import { ThemeProvider } from "@emotion/react";
import CustomHeader from "./custom/CustomHeader";
import CustomNavBar from "./custom/CustomNavBar";
import CustomFooter from "./custom/CustomFooter";
import ScrollToTop from "../components/ScrollToTop";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

//Theme importing
import defaultTheme from "../themes/defaultTheme";
import PageHeader from "./main/PageHeader";
import Creator from "./main/Creator";
import SpotLight from "./main/SpotLight";
import AdmissionModal from "../components/AdmissionModal";
// import AdmissionPopUP_Png_2022_25 from "../assets/website_Popups/MCOPT-NOTICE FOR ADMISSION POPUP.png";
import popupImg from "../../src/assets/website_Popups/POP_UP_2026_27.jpeg";
export interface LayoutProps {
  children: ReactNode;
  layout: string;
}

const Layout: FC<LayoutProps> = ({ children, layout }: LayoutProps) => {
  const [open, setOpen] = useState(true);
  return (
    <ThemeProvider theme={defaultTheme}>
      <AdmissionModal
        open={open}
        setOpen={setOpen}
        src={popupImg}
      />
      {layout === "custom" ? (
        <div
          style={{
            position: "relative",
            minHeight: "100vh",
            width: "100vw",
            maxWidth: "100vw",
            minWidth: "100vw",
          }}
        >
          <CustomHeader />
          <CustomNavBar />
          <div>{children}</div>
          <CustomFooter />
        </div>
      ) : (
        <div
          style={{
            position: "relative",
            minHeight: "100vh",
            width: "100vw",
            maxWidth: "100vw",
            minWidth: "100vw",
          }}
        >
          <Header />
          <NavBar />
          <SpotLight />
          <PageHeader />
          <div style={{ width: "100vw", maxWidth: "100%" }}>{children}</div>
          <Footer />
          <Creator />
          <ScrollToTop>
            <Fab
              sx={{ color: "primary.main", backgroundColor: "text.secondary" }}
              size="small"
              aria-label="scroll back to top"
            >
              <KeyboardArrowUpIcon />
            </Fab>
          </ScrollToTop>
        </div>
      )}
    </ThemeProvider>
  );
};

export default Layout;
